import React, {useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import DraggableModalDialog from '../DraggableModalDialog/DraggableModalDialog'
import LocaleDate from '../LocaleDate/LocaleDate'
import {
	createProspectiveClient,
	convertProspectiveClient,
	hideProspects
} from '../users/usersSlice'

import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'

const Creator = ({hide})=>{
	const dispatch = useDispatch()

	const [name,setName] = useState('')
	const [email,setEmail] = useState('')
	const [phone,setPhone] = useState('')
	const [message,setMessage] = useState('')

	const [isPending,setIsPending] = useState(false)
	const handleCreate = ()=>{
		setIsPending(true)
		dispatch(createProspectiveClient({name,client_email:email,phone,message}))
		.then(()=>{
			setIsPending(false)
			hide()
		})
	}

	const reset = ()=>{
		setName('')
		setEmail('')
		setPhone('')
		setMessage('')
	}

	return (
		<div className="mb-1">
			<strong>Name</strong>
			<Form.Control 
				onChange={e=>{
					setName(e.target.value)
				}}
				value={name}
				placeholder="name"
			/>
			<strong>Email</strong>
			<Form.Control 
				onChange={e=>{
					setEmail(e.target.value)
				}}
				value={email}
				placeholder="email"
			/>
			<strong>Phone</strong>
			<Form.Control 
				onChange={e=>{
					setPhone(e.target.value)
				}}
				value={phone}
				placeholder="phone"
			/>
			<strong>Message/Comments</strong>
			<Form.Control 
				onChange={e=>{
					setMessage(e.target.value)
				}}
				value={message}
				as="textarea" 
				placeholder="Message/Comments"
			/>
			<div className="text-right mt-1">
				<Button 
					disabled={isPending || !Boolean(name) || !Boolean(email)}
					onClick={()=>{
						reset()
						hide()
					}}
					variant="outline-secondary" 
					size="sm"
				>
					Cancel
				</Button>
				<Button 
					disabled={isPending || !Boolean(name) || !Boolean(email)}
					onClick={handleCreate}
					variant="outline-success" 
					className="ml-1"
					size="sm"
				>
					Create {isPending&&<Spinner animation="border" size="sm"/>}
				</Button>
			</div>
			<hr/>
		</div>
	)
}

const Prospect = ({prospect})=>{
	const statusDispatch = useApiStatusDispatch()
	const handleConvert = (id)=>{
		setIsPending(true)
		statusDispatch(convertProspectiveClient({id}),'prospective client','convert')
			.then(()=>{
				setIsPending(false)
			})
	}
	const [isPending,setIsPending] = useState(false)
	return (
		<div
			className="mb-2 pb-2"
			style={{ borderBottom: '1px solid #ddd' }}
		>
			<div><span style={{ fontWeight: '600' }}>Name</span>: {prospect.name}</div>
			<div><span style={{ fontWeight: '600' }}>Email</span>: {prospect.email}</div>
			<div><span style={{ fontWeight: '600' }}>Phone</span>: {prospect.phone}</div>
			<div>
				<span style={{ fontWeight: '600' }}>Sent</span>: <LocaleDate 
					date={new Date(prospect.sent_at.split(' ').join('T'))}
					includeTime={true}
				/>
			</div>
			<div>
				<span style={{ fontWeight: '600' }}>Message</span>:
				<p style={{ whiteSpace: 'pre-wrap' }}>{prospect.message}</p>
			</div>
			<div className="text-right">
				<Button
					onClick={handleConvert.bind(null,prospect.id)}
					disabled={isPending}
					variant="outline-success"
					size="sm"
				>
					Convert to client {isPending&&<Spinner animation="border" size="sm"/>}
				</Button>
			</div>
		</div>
	)
}

const ProspectViewer = () => {
	let dispatch = useDispatch();
	const {show,status,recent:prospects} = useSelector(state => state.users.prospects);
	console.log(prospects)
	const batchSize = 20
	const [displayCount,setDisplayCount] = useState(batchSize)
	const prospectsSlice = prospects.slice(0,displayCount)

	const [showCreator,setShowCreator] = useState(false)



	const handleShowMore = ()=>{
		setDisplayCount(p=>p+batchSize)
	}

	

	return (
		<Modal
			animation={false}
			dialogAs={DraggableModalDialog}
			show={show}
			onHide={()=>dispatch(hideProspects())}
			centered>
			<Modal.Header closeButton>
				<Modal.Title>Recent Prospects</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Button 
					onClick={()=>{
						setShowCreator(p=>!p)
					}}
					variant="outline-success"
					className="mb-1"
					block
				>
					Add Prospective Client
				</Button>
				{showCreator&& 
					<Creator 
						hide={
							()=>{ setShowCreator(false) }
						}
					/>
				}
				{
					status === 'loading' ?
						<div className="text-center">
							<Spinner animation="border" role="status">
								<span className="sr-only">Loading...</span>
							</Spinner>
						</div>
						:
						<>
							{prospectsSlice.map( (prospect, i) => (
								<Prospect 
									key={prospect.id} 
									prospect={prospect}
								/>
							))}
							{displayCount<prospects.length&&
								<Button
									className="mt-2"
									block
									variant="outline-primary"
									size="sm"
									onClick={handleShowMore}
								>
									Load More...
								</Button>
							}
						</>
				}
			</Modal.Body>
		</Modal>
	)
}

export default ProspectViewer